mtl.alloy.factory.form = (function($) {
    'use strict';

    /**
     * Return the form factory function.
     */
    return function(element, options) {

        var $element = $(element).first();
        element = $element[0];


        /**
         * Update form validity.
         */
        function updateFormValidity(_filterTest) {

            if (typeof element.checkValidity !== 'function') {
                return;
            }

            var isValid = !!element.checkValidity();

            if (_filterTest != null && (!!_filterTest) !== isValid) {
                return;
            }

            $element.toggleClass('is-valid', isValid);

        }


        /**
         * Update the input `has-value` state.
         */
        function updateHasValue(_input) {

            var $input = $(_input);

            $input.toggleClass('no-value', $input.val().trim() === '');

        }


        /**
         * On input change event handler.
         */
        function onInputChange(_event) {

            updateHasValue(_event.currentTarget);
            updateFormValidity(false);

        }


        /**
         * On input blur event handler.
         */
        function onInputBlur(_event) {

            var $input = $(_event.currentTarget);

            $input.addClass('can-show-invalid');

            updateHasValue($input);
            updateFormValidity();

        }


        // Bind input event listeners
        $element.find('input').not('[type="hidden"]').add($element.find('textarea'))
            .on('change input paste cut', onInputChange)
            .on('blur', onInputBlur)
            .each(function(i, _input) {
                updateHasValue(_input);
            })
        ;

        updateFormValidity();

    };

}(jQuery));
